'use client';

import { useEffect, useState } from 'react';
import { Flame, Star, Tag } from 'lucide-react';
import { t } from '@/i18n/t';
type Locale = Parameters<typeof t>[0];

export type Etikett = 'bast_saljande' | 'favorit' | 'basta_pris';
const FLAGGA = 'af-forhandsvisa-etiketter';

/**
 * Etiketten på produktkortet — Bäst säljande, Favorit eller Bäst pris (räknas i API:et, lib/etiketter.ts). Ägaren
 * 2026-10-09: "lägg labels på dem så folk inte blir förvirrade". Bakom förhandsvisning tills ägaren sett texterna:
 * ?forhandsvisa=etiketter slår på (sparas i webbläsaren), ?forhandsvisa=av slår av.
 */
export function useEtiketterPa(): boolean {
  const [pa, setPa] = useState(false);
  useEffect(() => {
    try {
      const q = new URLSearchParams(window.location.search).get('forhandsvisa');
      if (q === 'etiketter') localStorage.setItem(FLAGGA, '1');
      if (q === 'av') localStorage.removeItem(FLAGGA);
      setPa(localStorage.getItem(FLAGGA) === '1');
    } catch { /* privat läge: ingen förhandsvisning */ }
  }, []);
  return pa;
}

const STIL: Record<Etikett, { ikon: typeof Flame; klass: string }> = {
  bast_saljande: { ikon: Flame, klass: 'bg-orange-100 text-orange-900 border-orange-300' },
  favorit: { ikon: Star, klass: 'bg-brand/10 text-brand border-brand/30' },
  basta_pris: { ikon: Tag, klass: 'bg-emerald-100 text-emerald-900 border-emerald-300' },
};

export function ProduktEtikett({ etikett, locale }: { etikett?: Etikett | null; locale: Locale }) {
  const pa = useEtiketterPa();
  if (!pa || !etikett || !STIL[etikett]) return null;
  const { ikon: Ikon, klass } = STIL[etikett];
  return (
    <span title={t(locale, `product.etikett.${etikett}.tips`)}
      className={`mb-1 inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] sm:text-xs font-semibold ${klass}`}>
      <Ikon className="h-3 w-3" aria-hidden="true" />{t(locale, `product.etikett.${etikett}`)}
    </span>
  );
}
